import type { PropsWithChildren } from 'react';
import { Bar } from './bar';

// Decorative preview-card chrome (frame + faux browser bar) shared across onboarding steps; each step supplies its body.
export function GraphicFrame({ children }: PropsWithChildren) {
  return (
    <div
      aria-hidden
      // Fixed footprint so every step's preview is the same size down the checklist; the body fills
      // the remaining height and centres its content, so shorter steps pad to match the tallest.
      className="flex h-52.5 w-62 shrink-0 select-none flex-col overflow-hidden rounded-[10px] border border-gray-200 bg-white shadow-lg"
    >
      {/* macOS-style title bar */}
      <div className="flex items-center gap-1.5 border-gray-100 border-b bg-gray-50 px-3 py-2.5">
        <span className="block size-2 rounded-full bg-[#ff5f57]" />
        <span className="block size-2 rounded-full bg-[#febc2e]" />
        <span className="block size-2 rounded-full bg-[#28c840]" />
        <Bar className="ms-1 h-2 w-30" />
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
}
